module.exports = __webpack_public_path__ + "static/mr-concert-performance-16-454118c67e956a7b2afe3b2d151d0976.jpg";